export const frequencyPresets = [
  {
    id: "1x TÝDNĚ",
    translationKey: "offers.frequencies.1xWEEKLY",
    rrule_blueprint: "FREQ=WEEKLY;INTERVAL=1;BYDAY=MO",
  },
  {
    id: "2x TÝDNĚ",
    translationKey: "offers.frequencies.2xWEEKLY",
    rrule_blueprint: "FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TH",
  },
  {
    id: "3x TÝDNĚ",
    translationKey: "offers.frequencies.3xWEEKLY",
    rrule_blueprint: "FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,WE,FR",
  },
  {
    id: "4x TÝDNĚ",
    translationKey: "offers.frequencies.4xWEEKLY",
    rrule_blueprint: "FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TH,SA,SU",
  },
  {
    id: "5x TÝDNĚ",
    translationKey: "offers.frequencies.5xWEEKLY",
    rrule_blueprint: "FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TH,SA,SU,WE",
  },
  {
    id: "6x TÝDNĚ",
    translationKey: "offers.frequencies.6xWEEKLY",
    rrule_blueprint: "FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TH,SA,SU,WE,FR",
  },
  {
    id: "7x TÝDNĚ",
    translationKey: "offers.frequencies.7xWEEKLY",
    rrule_blueprint: "FREQ=WEEKLY;INTERVAL=1;BYDAY=MO,TH,SA,SU,WE,FR,TU",
  },
  {
    id: "1x 14 DNÍ",
    translationKey: "offers.frequencies.1x14DAYS",
    rrule_blueprint: "FREQ=WEEKLY;INTERVAL=2;BYDAY=MO",
  },
  {
    id: "1x MĚSÍČNĚ",
    translationKey: "offers.frequencies.1xMONTHLY",
    rrule_blueprint: "FREQ=MONTHLY;INTERVAL=1;BYMONTHDAY=1",
  },
  {
    id: "4x ROČNĚ",
    translationKey: "offers.frequencies.4xYEARLY",
    rrule_blueprint: "FREQ=MONTHLY;INTERVAL=3;BYMONTH=1,4,7,10;BYMONTHDAY=1",
  },
  {
    id: "2x ROČNĚ",
    translationKey: "offers.frequencies.2xYEARLY",
    rrule_blueprint: "FREQ=MONTHLY;INTERVAL=6;BYMONTH=1,7;BYMONTHDAY=1",
  },
  {
    id: "1x ROČNĚ",
    translationKey: "offers.frequencies.1xYEARLY",
    rrule_blueprint: "FREQ=YEARLY;INTERVAL=1;BYMONTH=1;BYMONTHDAY=1",
  },
];

export const getTranslatedFrequencyPresets = (t) =>
  frequencyPresets.map((preset) => ({
    ...preset,
    name: t(preset.translationKey),
  }));
